export default __webpack_public_path__ + "static/media/acido_3.e3a89049.jpg";